import type { HTMLAttributes } from 'react';
import { cn } from './cn.js';

type Tone = 'gold' | 'green' | 'red' | 'neutral' | 'warn' | 'success' | 'danger';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  size?: 'sm' | 'md';
}

const tones: Record<Tone, string> = {
  gold: 'bg-gold/10 text-gold-light border-gold/25',
  green: 'bg-success/10 text-success border-success/25',
  success: 'bg-success/10 text-success border-success/25',
  red: 'bg-danger/10 text-danger border-danger/25',
  danger: 'bg-danger/10 text-danger border-danger/25',
  warn: 'bg-warn/10 text-warn border-warn/25',
  neutral: 'bg-raise text-text-dim border-line',
};

const sizes = {
  sm: 'px-2 py-0.5 text-[10px]',
  md: 'px-2.5 py-1 text-[11px]',
};

export function Badge({ tone = 'neutral', size = 'sm', className, ...rest }: BadgeProps) {
  return (
    <span
      {...rest}
      className={cn(
        'inline-flex items-center rounded-md border font-semibold uppercase tracking-wider',
        tones[tone],
        sizes[size],
        className,
      )}
    />
  );
}
